import type { FieldsetProps as MantineFieldsetProps } from '@mantine/core';
import { Fieldset as MantineFieldset } from '@mantine/core';

import type { LockedProps } from '../types';

export type FieldsetProps = Omit<MantineFieldsetProps, LockedProps>;

/**
 * ### Fieldset
 *
 * @description
 * Mantine's Fieldset minus per-call-site style overrides (see {@link LockedProps}). Groups related
 * form controls; `legend` labels the group and `disabled` disables every control inside it.
 *
 * @example
 * ```tsx
 * <Fieldset legend="Personal information">
 *   <TextInput label="Name" />
 * </Fieldset>
 * ```
 *
 * @param props - {@link FieldsetProps}
 * @returns React component
 */
export const Fieldset = (props: FieldsetProps) => <MantineFieldset {...props} />;
